<template>
  <div>
    <h2>Памятка по поисковому продвижению (seo), практические рекомендации от специалистов компании Demis Group</h2>

    <p><span class="text-bold">Основная задача коммерческого сайта – продажи</span>. Чем более развитым и интересным для пользователей будет Ваш сайт, тем больше заявок, звонков и продаж Вы получите. Поисковые системы уже научились отслеживать то, насколько интересен сайт пользователям, и оценивать различные коммерческие параметры ресурса (широта ассортимента, уровень цен, уникальность торговых предложений и т.д.). Следовательно, чем лучше сайт для пользователей, тем он лучше и для поисковых систем. Планомерная работа над развитием ресурса приводит к росту позиций сайта и стабильному нахождению в ТОП поисковых систем.</p>

    <accordion-item
      :index="1"
      title="1. Рекомендации по повышению эффективности работы сайта"
    >
      <ol>
        <li>
          <p class="text-bold">
            Рекомендуется создание новых разделов и регулярная актуализация информации в этих разделах.
          </p>

          <ul>
            <li>
              <span class="text-bold">Раздел «Новости»</span> – размещать уникальные тексты новостей о событиях, происходящих в Вашей компании или в Вашей отрасли (желательно не реже, чем 1 раз в неделю).
              В целях содействия эффективному развитию Вашего сайта специалисты «Demis Group» могут подготовить тексты новостей (пресс-релизов) на основе предоставленной Вами информации, которые будут размещены на авторитетных площадках интернета для создания благоприятного имиджа компании и увеличения посещаемости сайта.
              Примеры информационных поводов для новостей: обновление ассортимента и новые услуги, участие в выставке, семинаре, конференции, открытие филиала (офиса, представительства), выход на новый рынок, получение сертификата (диплома, премии), назначение на должность, новый проект (клиент).
              О появлении новых информационных поводов необходимо сообщать Вашему персональному менеджеру.
            </li>
            <li><span class="text-bold">Раздел «Спецпредложения» («Акции», «Скидки»)</span> – размещать актуальную информацию о скидках, спецпредложениях, бонусах, подарках клиентам, конкурсах – с указанием условий и сроков проведения.</li>
            <li><span class="text-bold">Раздел «Статьи» («Полезные советы»)</span> – размещать тексты о выборе продукции (услуги), об особенностях продукции, рекомендации по использованию/эксплуатации.</li>
            <li><span class="text-bold">Раздел «Часто задаваемые вопросы»</span> – размещать типовые вопросы с подробными ответами. Ссылку на раздел «Часто задаваемые вопросы» желательно разместить в основном меню сайта.</li>
            <li><span class="text-bold">Страница «О Компании» («О нас»)</span> – размещать информацию об истории компании, ее успехах, наградах, сертификатах, лицензиях на продукцию, руководстве фирмы, платежных реквизитах и др.</li>
            <li><span class="text-bold">Раздел «Портфолио» («Выполненные проекты», «Отзывы»)</span> – размещать описание выполненных проектов, фотографии, отзывы и комментарии клиентов.</li>
            <li><span class="text-bold">Раздел «Каталог»</span> – размещать товары или услуги по группам (категориям). Ссылка на раздел «Каталог» должна быть заметной и присутствовать на каждой странице сайта. Чем более подробная и полезная информация о продукции (услугах) будет в каталоге (отличительные характеристики, стоимость, достоинства и ограничения каждого из товаров и на странице конкретного товара), тем более конверсионным будет этот раздел и сайт в целом.</li>
          </ul>
        </li>

        <li>
          <p class="text-bold">
            Рекомендуется внедрение сервисов, повышающих удобство работы с каталогом посетителям Вашего сайта:
          </p>
          <p>сортировка продукции; сравнение товаров; «калькулятор» или аналогичный сервис подсчета стоимости/количества и других подобных сервисов. Для сайтов, предлагающих товары, необходим функционал «корзины» покупателя.</p>
        </li>

        <li>
          <p class="text-bold">
            Необходимо оказание содействия специалистам Demis Group в работе над сайтом и продвижением:
          </p>
          <ul>
            <li>оперативно рассматривать и одобрять рекомендации, представленные сотрудниками Demis Group;</li>
            <li>оперативно вносить рекомендации, если оговорено самостоятельное внесение правок на сайт;</li>
            <li>предоставлять специалистам Demis Group доступы к сайту, к счетчикам статистики; содействовать в решении технических задач по сайту;</li>
            <li>оперативно предоставлять информацию для развития и наполнения сайта;</li>
            <li>обеспечивать возможность своевременного выхода на связь (если контактное лицо не может временно решать вопросы по продвижению проекта, то необходимо организовать его замещение);</li>
            <li>если для Вашего сайта запущена <span class="text-bold">кампания по контекстной рекламе</span> (например, Яндекс.Директ), изменение URL потребует ее перенастройки (на новые URL); поэтому в случае наличия контекстной кампании для сайта <span class="text-bold">обязательно</span> сообщите специалистам Demis Group <span class="text-bold">до</span> внесения правок.</li>
          </ul>
        </li>
      </ol>
    </accordion-item>

    <accordion-item
      :index="2"
      title="2. Рекомендации, наиболее важные для эффективного развития сайта и роста позиций"
    >
      <p class="text-center">
        <img
          src="../../../img/faq/aboutdemis/warningrecom.png"
          alt="Важно!"
        >
      </p>

      <p class="text-bold">
        Рекомендуется создание или актуализация разделов и развитие функциональности сайта:
      </p>

      <ol>
        <li>
          <span class="text-bold">Страница «Контакты»</span> – размещение <span class="text-bold">подробной контактной информации</span> на сайте: телефон/факс, e-mail, адрес, карта проезда, а также график работы компании.
        </li>
        <li>
          <span class="text-bold">Страница с контактами</span> должна быть <span class="text-bold">создана отдельно</span> и быть <span class="text-bold">доступной со всех страниц сайта</span> (т.е. ссылка на страницу «Контакты» должна присутствовать на каждой странице сайта).
        </li>
        <li>
          <span class="text-bold">Раздел «Как купить»</span> – размещение подробной информации о процедуре покупки продукции, возможных вариантах оплаты и сопутствующих услугах (доставка, скидки на доставку при покупке определенных видов товаров или специальные предложения) в разделе «Способы оплаты» и «Варианты доставки».
        </li>
        <li>
          <span class="text-bold">Форма обратной связи и обратного звонка, онлайн-консультант</span> – дополнительная возможность для посетителей Вашего сайта получить квалифицированную консультацию. Должна присутствовать на каждой странице сайта.
        </li>
        <li>
          <span class="text-bold">Форма поиска по сайту</span> – для улучшения удобства пользования сайтом со стороны потенциальных клиентов необходимо разместить форму «Поиск по сайту». Форма «Поиск по сайту» должна быть доступной со всех страниц сайта.
        </li>
        <li>
          <span class="text-bold">Инструкция по использованию сервисов сайта</span> – необходимо разместить структурированную и изложенную простым языком информацию/инструкции по пользованию сервисами сайта в разделе «Сервисы сайта» или «Как пользоваться сервисами сайта».
        </li>
      </ol>
    </accordion-item>

    <accordion-item
      :index="3"
      title="3. Не рекомендуется без согласования со специалистами Demis Group"
    >
      <ul>
        <li>Размещение на страницах сайта внешних ссылок (в том числе кнопки различных сетевых ресурсов: рейтинги, порталы, не закрытые атрибутом rel="nofollow" и тегом "noindex").</li>
        <li>Размещение на страницах сайта баннеров, рекламных объявлений, которые не имеют отношения к основной деятельности компании.</li>
        <li>Размещение кода Uptolike (сервиса социальной активности пользователей), рекомендуется использование аналогичных сервисов от Яндекса. Иначе поисковые системы могут заподозрить накрутку поведенческих факторов.</li>
        <li>
          Удаление или корректировка контента без заблаговременного предупреждения на <span class="text-bold">продвигаемых страницах</span> и внесение изменений:
          <ul>
            <li>в названии компании на сайте;</li>
            <li>в контактные данные;</li>
            <li>в раздел «Каталог продукции (услуг)».</li>
          </ul>
        </li>
        <li>Удаление кодов счетчиков статистики.</li>
        <li>Изменение настроек редиректов.</li>
        <li>Изменение файлов robots.txt.</li>
        <li>Создание сайтов-клонов подобной или смежной тематики.</li>
        <li>Изменение дизайна и CMS сайта.</li>
        <li>Изменение хостинга (перенос сайта на другой хостинг).</li>
        <li>Самостоятельное устранение ошибок и неточностей в текстах или функционале. При их обнаружении необходимо незамедлительно сообщать специалистам Demis Group.</li>
      </ul>

      <img
        src="../../../img/faq/aboutdemis/keyboard.png"
        alt="Keyboard"
        style="float: left; margin: 5px 5px 5px 0; max-width: 100%"
      >
      <p style="font-style: italic">
        Если Вы обнаружили неточности в информации на сайте, то проинформируйте об этом специалистов Demis Group, для этого можно воспользоваться в открытом окне браузера кнопкой PrintScreen (PrtSc).
      </p>
      <p style="font-style: italic">
        После этого Вы можете вставить снимок своего экрана в текст документа (письма) и переслать для уточнения. Кроме того, просьба указать тип браузера, который был использован для просмотра страницы, адрес (URL) страницы и прочую информацию.
      </p>
    </accordion-item>

    <accordion-item
      :index="4"
      title="4. Ошибки, наиболее критичные для продвижения и работы сайта"
    >
      <p class="text-center">
        <img
          src="../../../img/faq/aboutdemis/warningerrors.png"
          alt="Важно!"
        >
      </p>

      <ul>
        <li>
          <p class="text-bold">
            Несвоевременная оплата услуг хостинга и аренды доменного имен
          </p>
          <img
            src="../../../img/faq/aboutdemis/exclam.png"
            alt="Exclam"
            class="exclam"
          >
          <div class="exclam-block">
            <p class="text-bold">
              Последствия
            </p>
            <ul>
              <li style="font-style: italic">
                отсутствие оплаты за хостинг приводит к полному удалению всех файлов (полной информации) с серверов и невозможности ее восстановления, а также к необходимости перезаключения договоров;
              </li>
              <li style="font-style: italic">
                отсутствие оплаты за домен приводит к тому, что сайт перестает работать, а затем к выставлению самого доменного имени на аукцион и продаже третьим лицам, а следовательно, к бесповоротной потере всех достигнутых позиций сайта в поисковых системах, посетителей сайта, инвестиций в продвижение сайта.
              </li>
            </ul>
          </div>
        </li>
        <li>
          <p class="text-bold">
            Удаление (изменение) страниц, изменение URL страниц, изменение (удаление) контента на продвигаемых страницах без согласования со специалистами Demis Group
          </p>
          <img
            src="../../../img/faq/aboutdemis/exclam.png"
            alt="Exclam"
            class="exclam"
          >
          <div class="exclam-block">
            <p class="text-bold">
              Последствия
            </p>
            <ul>
              <li style="font-style: italic">
                поисковые системы могут просканировать сайт, сохранив в своей базе информацию о том, что сайт не является релевантным по соответствующим запросам, что может привести к падению позиций;
              </li>
              <li style="font-style: italic">
                отсутствие заказов и контактов клиентов;
              </li>
              <li style="font-style: italic">
                снижение эффективности инвестиций в SEO, контекстную рекламу и другие маркетинговые инструменты.
              </li>
            </ul>
          </div>
        </li>
        <li>
          <p class="text-bold">
            Неподдержание работоспособности интерактивных форм взаимодействия с пользователями (форм заказов, форм обратной связи) и e-mail адресов
          </p>
          <img
            src="../../../img/faq/aboutdemis/exclam.png"
            alt="Exclam"
            class="exclam"
          >
          <div class="exclam-block">
            <p class="text-bold">
              Последствия
            </p>
            <ul>
              <li style="font-style: italic">
                потеря заказов и контактов клиентов из-за неработоспособности корзины, функции заказа звонков или других онлайн-сервисов;
              </li>
              <li style="font-style: italic">
                ухудшение мнения пользователей, формирование негатива у потенциальных и существующих клиентов из-за нерабочих форм коммуникаций;
              </li>
              <li style="font-style: italic">
                снижение эффективности инвестиций в SEO, контекстную рекламу и другие маркетинговые инструменты.
              </li>
            </ul>
          </div>
        </li>
        <li>
          <p class="text-bold">
            Размещение спама на страницах (клоакинг, скрытый текст и т.д.) и adult-контента (например, «порно») и ссылок на подобный контент на сайте
          </p>
          <img
            src="../../../img/faq/aboutdemis/exclam.png"
            alt="Exclam"
            class="exclam"
          >
          <div class="exclam-block">
            <p class="text-bold">
              Последствия
            </p>
            <ul>
              <li style="font-style: italic">
                если поисковые системы обнаружат спам или adult-контент, то они могут наложить фильтр или понизить позиции сайта в поисковых системах;
              </li>
              <li style="font-style: italic">
                отсутствие заказов и контактов клиентов;
              </li>
              <li style="font-style: italic">
                снижение эффективности инвестиций в SEO, контекстную рекламу и другие маркетинговые инструменты.
              </li>
            </ul>
          </div>
        </li>
        <li>
          <p class="text-bold">
            Неактуальный и необновляемый контент на сайте
          </p>
          <img
            src="../../../img/faq/aboutdemis/exclam.png"
            alt="Exclam"
            class="exclam"
          >
          <div class="exclam-block">
            <p class="text-bold">
              Последствия
            </p>
            <ul>
              <li style="font-style: italic">
                устаревший контент создает ощущение «заброшенности» сайта, что, в свою очередь, негативно сказывается на степени доверия к нему со стороны посетителей;
              </li>
              <li style="font-style: italic">
                многие посетители, не найдя на сайте свежего контента, предпочтут покинуть ресурс – это влечет повышение процентов отказов;
              </li>
              <li style="font-style: italic">
                снижение эффективности инвестиций в SEO, контекстную рекламу и другие маркетинговые инструменты.
              </li>
            </ul>
          </div>
        </li>
        <li>
          <p class="text-bold">
            Использование сервисов накрутки поведенческих факторов
          </p>
          <img
            src="../../../img/faq/aboutdemis/exclam.png"
            alt="Exclam"
            class="exclam"
          >
          <div class="exclam-block">
            <p class="text-bold">
              Последствия
            </p>
            <ul>
              <li style="font-style: italic">
                если поисковые системы обнаружат накрутку, то сайт по многим запросам будет пессимизирован, трафик на сайт резко упадет, что повлечет за собой снижение продаж;
              </li>
              <li style="font-style: italic">
                сайт может попасть под поведенческий фильтр, вывод из-под которого может занять от несколько месяцев до 1-2 лет;
              </li>
              <li style="font-style: italic">
                отсутствие заказов и контактов клиентов;
              </li>
              <li style="font-style: italic">
                снижение эффективности инвестиций в SEO, контекстную рекламу и другие маркетинговые инструменты.
              </li>
            </ul>
          </div>
        </li>
        <li>
          <p class="text-bold">
            Размещение на сайте контактных телефонов, по которым невозможно дозвониться (необходимо периодически контролировать эффективность работы собственных менеджеров)
          </p>
          <img
            src="../../../img/faq/aboutdemis/exclam.png"
            alt="Exclam"
            class="exclam"
          >
          <div class="exclam-block">
            <p class="text-bold">
              Последствия
            </p>
            <ul>
              <li style="font-style: italic">
                сайт могут исключить из Яндекс.Справочника, что негативно скажется на позициях;
              </li>
              <li style="font-style: italic">
                негативное влияние на репутацию компании;
              </li>
              <li style="font-style: italic">
                неэффективная обработка заказов, потеря части клиентов;
              </li>
              <li style="font-style: italic">
                снижение эффективности инвестиций в SEO, контекстную рекламу и другие маркетинговые инструменты.
              </li>
            </ul>
          </div>
        </li>
        <li>
          <p class="text-bold">
            Самостоятельное наращивание ссылочной массы через биржи ссылок и агрегаторы
          </p>
          <img
            src="../../../img/faq/aboutdemis/exclam.png"
            alt="Exclam"
            class="exclam"
          >
          <div class="exclam-block">
            <p class="text-bold">
              Последствия
            </p>
            <ul>
              <li style="font-style: italic">
                возможное наложение фильтра на домен за некачественную входящую ссылочную массу;
              </li>
              <li style="font-style: italic">
                стагнация или проседание по позициям и трафику;
              </li>
              <li style="font-style: italic">
                неэффективная обработка заказов, потеря части клиентов;
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </accordion-item>

    <p>Если Ваш сайт ранее продвигался в другой SEO компании, и Вам известно, что в процессе продвижения использовались запрещенные методы раскрутки (например, накрутка поведенческих факторов, что в последнее время крайне распространено), необходимо незамедлительно сообщить об этом специалистам Demis Group.</p>
    <p>Если у Вас есть сайты схожей тематики, также необходимо сообщить о них Вашему персональному менеджеру для устранения угрозы аффилирования.</p>
    <p>Своевременное информирование о различных проблемах в большинстве случаев помогает предотвратить наложение фильтров, а также падение позиций и трафика.</p>
    <p><span class="text-bold">ВАЖНО:</span> Выполнение вышеуказанных рекомендаций позволит сделать сотрудничество максимально продуктивным, достигнуть высоких результатов в кратчайшие сроки, обеспечить их стабильность и устойчивость, а также позволит значительно увеличить продажи с Вашего сайта</p>
  </div>
</template>

<script>
import AccordionItem from '../../components/views/faq/AccordionItem'
export default {
  name: 'AboutDemis',
  components: { AccordionItem }
}
</script>

<style lang="scss" scoped>
.exclam {
  float: left;
  width: 40px;
}

.exclam-block {
  margin-left: 50px;

  ul {
    padding-left: 17px;
  }
}

img {
  max-width: 100%;
}
</style>
